import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideMarkdown } from 'ngx-markdown';
import { providePrimeNG } from 'primeng/config';
import { YurestPreset, yurestThemeOptions } from '@app/theme/yurest-preset';

import { AppComponent } from '@app/app.component';
import { routes } from '@app/app.routes';
import { authInterceptor } from '@app/services/auth.interceptor';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    provideMarkdown(),
    providePrimeNG({
      theme: {
        preset: YurestPreset,
        options: yurestThemeOptions,
      },
      translation: {
        // DatePicker
        dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
        monthNames: [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre',
        ],
        monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        today: 'Hoy',
        clear: 'Limpiar',
        weekHeader: 'Sem',
        firstDayOfWeek: 1,
        dateFormat: 'dd/mm/yy',
        // Botones y acciones
        accept: 'Aceptar',
        reject: 'Rechazar',
        choose: 'Elegir',
        upload: 'Subir',
        cancel: 'Cancelar',
        pending: 'Pendiente',
        // File upload
        fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        // Filtros y búsqueda
        startsWith: 'Comienza con',
        contains: 'Contiene',
        notContains: 'No contiene',
        endsWith: 'Termina con',
        equals: 'Igual a',
        notEquals: 'Distinto de',
        lt: 'Menor que',
        lte: 'Menor o igual que',
        gt: 'Mayor que',
        gte: 'Mayor o igual que',
        is: 'Es',
        isNot: 'No es',
        before: 'Antes',
        after: 'Después',
        dateIs: 'Fecha es',
        dateIsNot: 'Fecha no es',
        dateBefore: 'Fecha antes de',
        dateAfter: 'Fecha después de',
        matchAll: 'Coincidir todos',
        matchAny: 'Coincidir cualquiera',
        addRule: 'Añadir regla',
        removeRule: 'Eliminar regla',
        apply: 'Aplicar',
        // Tabla
        emptyMessage: 'No se encontraron resultados',
        emptyFilterMessage: 'No se encontraron resultados',
        emptySearchMessage: 'No se encontraron resultados',
        emptySelectionMessage: 'Ningún elemento seleccionado',
        selectionMessage: '{0} elementos seleccionados',
        // Paginación
        aria: {
          trueLabel: 'Verdadero',
          falseLabel: 'Falso',
          nullLabel: 'No seleccionado',
          star: '1 estrella',
          stars: '{star} estrellas',
          selectAll: 'Todos los elementos seleccionados',
          unselectAll: 'Todos los elementos deseleccionados',
          close: 'Cerrar',
          previous: 'Anterior',
          next: 'Siguiente',
          navigation: 'Navegación',
          scrollTop: 'Ir arriba',
          moveTop: 'Mover arriba',
          moveUp: 'Subir',
          moveDown: 'Bajar',
          moveBottom: 'Mover abajo',
          moveToTarget: 'Mover al destino',
          moveToSource: 'Mover al origen',
          moveAllToTarget: 'Mover todo al destino',
          moveAllToSource: 'Mover todo al origen',
          pageLabel: 'Página {page}',
          firstPageLabel: 'Primera página',
          lastPageLabel: 'Última página',
          nextPageLabel: 'Siguiente página',
          prevPageLabel: 'Página anterior',
          rowsPerPageLabel: 'Filas por página',
          jumpToPageDropdownLabel: 'Ir a página',
          jumpToPageInputLabel: 'Ir a página',
          selectRow: 'Fila seleccionada',
          unselectRow: 'Fila deseleccionada',
          expandRow: 'Fila expandida',
          collapseRow: 'Fila contraída',
          showFilterMenu: 'Mostrar menú de filtros',
          hideFilterMenu: 'Ocultar menú de filtros',
          filterOperator: 'Operador de filtro',
          filterConstraint: 'Restricción de filtro',
          editRow: 'Editar fila',
          saveEdit: 'Guardar edición',
          cancelEdit: 'Cancelar edición',
          listView: 'Vista de lista',
          gridView: 'Vista de cuadrícula',
          slide: 'Diapositiva',
          slideNumber: '{slideNumber}',
          zoomImage: 'Ampliar imagen',
          zoomIn: 'Acercar',
          zoomOut: 'Alejar',
          rotateRight: 'Girar a la derecha',
          rotateLeft: 'Girar a la izquierda',
        },
      },
    }),
  ],
}).catch((err) => console.error(err));
